import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { setupVueI18n } from '@/plugin/vue-i18n';
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import { provide } from 'vue';
import PaymentLinksEditor from '../components/payment-links-editor/PaymentLinksEditor.vue';
import '../index.css';
import { setupPinia } from '../plugin/pinia';
import { useMainStore } from '../store/main';
import { AltType } from '../utils/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinksEditorApp',
    props: {
        route: Object,
        router: Object,
        emitter: Object,
        store: Object,
        contact: Object,
        contactId: String,
        locationId: String,
        locale: String,
        currency: String,
        timezone: String,
        user: Object,
    },
    setup(__props) {
        const props = __props;
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('store', props.store);
        provide('locationId', props.locationId);
        provide('user', props.user);
        setupVueI18n(props.locale);
        setupPinia();
        const microAppStore = useMainStore();
        microAppStore.setAppInitData({
            currency: props.currency,
            timezone: props.timezone,
            altId: props.locationId,
            altType: AltType.LOCATION,
        });
        /* DON't write any direct logics here because if we use
        composition here it won't be able to access providers
        */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(UIContentWrap), { "full-screen": true }, {
                    default: _withCtx(() => [
                        _createVNode(PaymentLinksEditor)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
